<template>
  <div
    class="f-column mh-0 w-100"
    style="gap: 1rem; max-height: 100%"
  >
    <GwInputNew
      v-if="items.length"
      :placeholder="$t('common.search')"
      :value="name"
      @update:value="value => (name = value)"
    />

    <TableBody
      ref="tablebody"
      :items="l_items"
      :isInfinite="false"
      size="small"
      class="mh-0"
      style="
        min-height: 0;
        --overflow-y-head: scroll;
        --overflow-y-body-scroller: scroll;
        --min-height-table: clamp(1px, 42rem, 70vh);
        --max-height-table: 70vh;
        --container-no-data-position: relative;
      "
      :data-tst="`${tstPrefix}_table`"
    >
      <template #no_data>
        <div
          class="gw_box flex-1 f-center f-column"
          style="--clr-box-back: var(--clr-black-0-3)"
        >
          <IconAndText
            v-if="name"
            icon="mdi-magnify"
            class="anim-fade-in"
            :title="$t('data_table.icm_structure.no_data')"
            :subtitle="$t('data_table.icm_structure.no_data_search_sub')"
          />
          <IconAndText
            v-else
            icon="mdi-folder"
            class="anim-fade-in"
            :title="$t('data_table.icm_structure.no_data')"
            :subtitle="$t('data_table.icm_structure.no_data_sub')"
          />
        </div>
      </template>
      <template #head_before>
        <TableHead
          v-if="l_items.length"
          :sortConf="tbl_sortConf"
          :thead="thead"
          class="large-scroll-track"
          @click:th="tbl_handleSort"
        >
        </TableHead>
      </template>
      <template #default="{ item, index }">
        <IcmStructuresTableRow
          :thead
          :item
          :hasDelete
          :data-tst="`${tstPrefix}_row_${index}`"
          v-bind="$attrs"
        >
        </IcmStructuresTableRow>
      </template>
    </TableBody>
  </div>
</template>

<script>
import TableHead from '@/components/DataTables/v2/TableHead'
import TableBody from '@/components/DataTables/v2/TableBody'
import IcmStructuresTableRow from '@/components/DataTables/v2/tables/IcmStructuresTable/IcmStructuresTableRow'
import table_mix from '@/components/DataTables/table_mix'
import GwInputNew from '@/components/lib/GwInputNew'
import Fuse from 'fuse.js'
import IconAndText from '@/components/Poker/Overlays/IconAndText'

export default {
  name: 'IcmStructuresTable',
  components: {
    TableHead,
    TableBody,
    IcmStructuresTableRow,
    GwInputNew,
    IconAndText,
  },
  mixins: [table_mix],
  props: {
    items: { type: Array, default: () => [] },
    tstPrefix: String,
    hasDelete: Boolean,
  },
  data() {
    return {
      tbl_sortConf: {
        sortKey: 'name',
        sortOrder: 'asc',
      },
      name: '',
    }
  },
  computed: {
    thead() {
      const cols = {
        name: {
          name: this.$t('table_head.name'),
          sortKey: 'name',
          width: 24,
        },
        tournament_type: {
          name: this.$t('table_head.tournament_type'),
          sortKey: 'type',
        },
        total_entrants: {
          name: this.$t('table_head.total_entrants'),
          sortKey: 'total_entrants',
          width: 8,
        },
      }
      const res = {}
      Object.keys(cols).forEach(key => {
        const col = cols[key]
        const width = col.width || col.minWidth
        res[key] = {
          key,
          ...col,
          cssStyle: !width
            ? ''
            : `
            --min-width-th: ${width}rem;
            ${col.minWidth ? '' : `--max-width-th: ${width}rem`};
            `,
          tdStyle: !width
            ? ''
            : `
            --min-width-td: ${width}rem;
            ${col.minWidth ? '' : `--max-width-td: ${width}rem`};
            `,
        }
      })
      return res
    },
    l_items() {
      let res = [...this.items]

      if (this.name) {
        const searchOpts = {
          shouldSort: true,
          includeScore: true,
          includeMatches: true,
          threshold: 0.6,
          location: 0,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: ['name'],
        }
        const fuseSearchResult = new Fuse(res, searchOpts) //
          .search(
            this.name, //
            searchOpts,
          )
        res = fuseSearchResult.map(result => result.item)
      }

      const { sortKey, sortOrder } = this.tbl_sortConf

      const getVal =
        sortKey === 'prize_pool' ? item => Number(item[sortKey]) : item => item[sortKey]
      if (sortOrder === 'desc') {
        res.sort((a, b) => (getVal(a) > getVal(b) ? -1 : 1))
      } else {
        res.sort((a, b) => (getVal(a) < getVal(b) ? -1 : 1))
      }

      return res
    },
  },
}
</script>
